import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import './layout.css'

class Layout extends React.Component {
  render () {
    return (
      <div>
        <div className="logo" />
        <ul className="menu">
          <li className="menu-item"><Link to="/">Home</Link></li>
          <li className="menu-item"><Link to="/about-us">About</Link></li>
        </ul>
        <div>
          {this.props.children}
        </div>
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.array
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/layout.js